export default function ({app: {router}}, inject) {
  if(false){
    // inject empty gtag function for disabled mode
    inject('gtag', () => {})
    return
  }

  window.dataLayer = window.dataLayer || []
  function gtag () {
    dataLayer.push(arguments)
    if(false){
      console.debug('gtag tracking called with following arguments:', arguments)
    }
  }
  inject('gtag', gtag)
  gtag('js', new Date())
  gtag('config','G-YZK1TDG51E',{
  "send_page_view": false
})

  if(!true){
    router.afterEach((to) => {
      gtag('config', 'G-YZK1TDG51E', {'page_path': to.fullPath})
    })
  }

  // additional accounts
}
